const NAME = "ASSETS_DISCOUNTS_SUMMARY";

export default NAME;
